import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import { LanguageProvider } from './i18n/LanguageContext';
import { ContentProvider } from './content/ContentContext';
import Header from './components/Header';
import CookieBanner from './components/CookieBanner';
import Footer from './components/Footer';
import Home from './pages/Home';
import Servizi from './pages/Servizi';
import TeamBuilding from './pages/TeamBuilding';
import ChristmasParty from './pages/ChristmasParty';
import Location from './pages/Location';
import Gallery from './pages/Gallery';
import Admin from './pages/Admin';
import ChiSiamo from './pages/ChiSiamo';
import Contatti from './pages/Contatti';

function ScrollToTop() {
  const { pathname } = useLocation();
  const first = React.useRef(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (first.current) {
      first.current = false;
      return;
    }
    if (window.gtag) {
      window.gtag('event', 'page_view', { page_path: pathname, page_title: document.title });
    }
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <ContentProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-ivory text-emerald-ink">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/team-building" element={<TeamBuilding />} />
              <Route path="/christmas-party" element={<ChristmasParty />} />
              <Route path="/location" element={<Location />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="top-center" richColors />
        <CookieBanner />
      </BrowserRouter>
      </ContentProvider>
    </LanguageProvider>
  );
}
